(() => {
  angular.module('finance').component('curlecPayoutListingComponent', {
    templateUrl: require('./curlecPayoutListing.component.html'),
    controller: CurlecPayoutListingComponent,
    controllerAs: 'vm',
    bindings: {
      pageState: '=',
    },
  });

  CurlecPayoutListingComponent.$inject = ['$scope', 'financeConstants'];

  function CurlecPayoutListingComponent($scope, financeConsts) {
    const vm = this;

    vm.loading = 0;

    vm.requestParams = {
      skipCount: 0,
      maxResultCount: financeConsts.grid.defaultPageSize,
      sorting: '',
    };

    vm.gridOptions = {
      ppScopeProvider: vm,
      paginationPageSizes: financeConsts.grid.defaultPageSizes,
      paginationPageSize: financeConsts.grid.defaultPageSize,
      paginationCurrentPage: 1,
      useExternalPagination: true,
      useExternalSorting: true,
      columnDefs: [
        {
          name: App.localize('Actions'),
          enableSorting: false,
          width: 100,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'actionTemplate',
        },
        {
          displayName: App.localize('Placeholder'),
          enableSorting: false,
          field: 'placeholder',
          minWidth: 200,
        },
      ],
      onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, (scope, callback) => {
          vm.requestParams.sorting =
            callback.length && callback[0].field
              ? `${callback[0].field} ${callback[0].sort.direction}`
              : null;
          getPaymentInstructionBatches();
        });
        gridApi.pagination.on.paginationChanged(
          $scope,
          App.setPagination(vm.requestParams, getPaymentInstructionBatches)
        );
      },
      data: [],
    };

    init();

    function init() {
      getPaymentInstructionBatches();
    }

    function getPaymentInstructionBatches() {
      vm.gridOptions.data = [
        {
          placeholder: 'Placeholder 1',
        },
        {
          placeholder: 'Placeholder 2',
        },
        {
          placeholder: 'Placeholder 3',
        },
      ];
    }
  }
})();
